<template>
    <div class="mainpage">
        <div class="def-settings col-lg-12 col-md-12 col-sm-12 mb-3">
            <p class="fw-bold">Application Header</p>
            <div class="d-flex align-items-center col-12 mb-2">
                <p class="mb-3">Customise the branding of application header to include your organisation's logo</p>
            </div>
            <p class="fw-bold">Upload logo</p>
            <div class="col-12 mb-2 upload-container ">
                <div class="upload-area" @click="openFileInput">
                    <img src="@/assets/images/upload_icon.svg" alt="Upload Icon" class="upload-icon" />
                    <p>File format PNG, SVG, JPG or JPEG (max size 500KB) </p>
                </div>
                <input type="file" ref="fileInput" accept="image/*" @change="handleFileUpload" style="display: none" />
            </div>
        </div>
        <div class="actions-btns">
            <div class="gap">
                <Button class="mr-3" :disabled="this.isDisabled" label="Update" @click="updateSettings"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapModels } from '@/utils'
import { urlProtocols, lengths } from '@/constants'

export default {
    name: 'AppBranding',
    components: {
    },
    data () {
        return {
            urlProtocols: urlProtocols,
            lengths: lengths
        }
    },
    methods: {
        async updateSettings () {
            const data = {
                default_domain: this.defaultShortUrl,
                default_length: this.defaultLength,
                default_protocol: this.defaultProtocol
            }
            this.globalLoader = true
            await this.$store.dispatch('Settings/Accounts/updateDefaultSetting', data)
            this.globalLoader = false
        },
        checkChanged () {
            if ((this.defaultShortUrl === this.getBeforeUpdate.defaultShortUrl) && (this.defaultProtocol === this.getBeforeUpdate.defaultProtocol) && (this.defaultLength === this.getBeforeUpdate.defaultLength)) {
                this.isDisabled = true
            } else {
                this.isDisabled = false
            }
        },
        openFileInput () {
            this.$refs.fileInput.click()
        },
        handleFileUpload (event) {
            const file = event.target.files[0]
        }
    },
    computed: {
        ...mapModels('general', ['globalLoader']),
        ...mapModels('Settings/Accounts', ['defaultShortUrl', 'defaultProtocol', 'defaultLength', 'isDisabled']),
        ...mapGetters({ currentUser: 'currentUser' }),
        ...mapGetters('Domains/Domain', ['getActiveDomains']),
        ...mapGetters('Settings/Accounts', ['getBeforeUpdate'])
    },
    async mounted () {
        this.$store.dispatch('Domains/Domain/fetchActiveDomains')
        await this.$store.dispatch('Settings/Accounts/fecthDefaultSettings')
    }
}
</script>

<style>
.def-settings {
    background-color: white;
    padding: 1rem;
}
.def-dropdown {
    width: 100%;
}
.upload-container {
  text-align: center;
  border: 3px dashed #ccc;
  padding: 30px;
  cursor: pointer;
}

.upload-area {
  position: relative;
  display: inline-block;
}

.upload-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}

.upload-area p {
  margin: 0;
}

</style>
